import React, {useEffect, useState} from 'react';
import {useAuth} from '../../hooks/use-auth';
import {registerOnSuccessSignin, unregisterOnSuccessSignin} from './user-login-event';
import {Spin} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';


const UserSession = (props) => {

    const [status, setStatus] = useState('loading');
    const { getCredentials, signIn} = useAuth();

    useEffect(() => {
        const authFlow = async () => {
            console.log('executando auth flow')
            if(window.location.href.indexOf('code') < 0){
                const cred = await getCredentials(setStatus);
                if(!cred.username){
                    signIn();
                } else {
                    setStatus('loggedIn');
                }
            } else {
                registerOnSuccessSignin(onSuccessLogin(setStatus));
            }
        }
        authFlow();

        return unregisterOnSuccessSignin(onSuccessLogin);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    
    if(status !== 'loading'){
        return (<>
            {[props.children]}
        </>);
    } else {
        return (<>
            <div className='confirmando-credenciais' style={{

                maxHeight: "100vh",
                padding: "20%",
                height: "100vh",
                display: "inline-block",
                width: "100%",
                textAlign: "center",
                background: "#ccc",
            }}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                
            </div>
        </>);
    }

}

const onSuccessLogin = setStatus => data => {
    setStatus('loggedIn');
    window.location = '/';
    
    
}

export {UserSession};